<template>
    <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view>
    <Toast position="bottom-right" />
</template>

<script>
import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useAnalyticsStore } from "@/store/analytics";
import { useAppStore } from "@/store/app";
import { useShopStore } from "@/store/shop";

export default {
    name: "App",

    setup() {
        const analyticsStore = useAnalyticsStore();
        const appStore = useAppStore();
        const shopStore = useShopStore();

        const { calendarRange } = storeToRefs(appStore);
        const { selectedShopId } = storeToRefs(shopStore);
        const { selectedGroupBy, groupByOptions } = storeToRefs(analyticsStore);

        onMounted(async () => {
            let params = new URLSearchParams(window.location.search);

            if (params.has("shop_id")) {
                selectedShopId.value = parseInt(params.get("shop_id"));
            }

            if (params.has("date_from")) {
                calendarRange.value[0] = new Date(params.get("date_from"));
            }

            if (params.has("date_to")) {
                calendarRange.value[1] = new Date(params.get("date_to"));
            }

            if (params.has("group_by")) {
                selectedGroupBy.value = groupByOptions.value.find((groupBy) => groupBy.code == params.get("group_by"));
            }

            userInputEventListener();
            generateUuid();
        });

        const userInputEventListener = () => {
            document.addEventListener("input", generateUuid);
            document.addEventListener("click", generateUuid);
        };

        const generateUuid = () => {
            appStore.setUuid();
        };
    },
};
</script>
